import { configureStore } from "@reduxjs/toolkit";
import { profilesSlice } from "./Profiles/profilesSlice";
import { PatientMapSelectSlice } from "./Profiles/PatientMapSelectSlice";

export const store = configureStore({
    reducer: {
        profiles: profilesSlice.reducer,
        patientMapSelect: PatientMapSelectSlice.reducer
    },
})